import { Injectable } from '@angular/core';
import { Json } from 'aws-sdk/clients/robomaker';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LambdaService {
  private apiKey: string = environment.lambdasApiKey;
  baseURL = environment.lambdasUri;

  private baseConfig = `{"credentials":"same-origin","headers":{"Accept":"application/json","Content-Type":"application/json","Authorization":"${this.apiKey}"},"method":""}`;
  ID = 'AKIA3ITLEVL4UTAFMU6W';

  constructor() { }

  //---------------------START BASE METHODS--------------------//
  async simpleGet(url: string) {
    let config = JSON.parse(this.baseConfig);
    config.method = 'GET';
    return new Promise((resolve, reject) => {
      fetch(this.baseURL + url, config)
        .then((response) => {
          response
            .json()
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async simplePost(url: string, body: any) {
    let config = JSON.parse(this.baseConfig);
    config.method = 'POST';
    config['body'] = body;
    return new Promise((resolve, reject) => {
      fetch(this.baseURL + url, config)
        .then((response) => {
          response
            .json()
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async simplePut(url: string, body: any) {
    let config = JSON.parse(this.baseConfig);
    config.method = 'PUT';
    config['body'] = body;
    return new Promise((resolve, reject) => {
      fetch(this.baseURL + url, config)
        .then((response) => {
          response
            .json()
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  //---------------------END BASE METHODS--------------------//

  getShops() {
    let url = `/shops`;
    return this.simpleGet(url);
  }

  getShopData(shopId: number) {
    let url = `/shop?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  getOnvoPayments() {
    let url = `/payments/onvo`;
    return this.simpleGet(url);
  }

  getInfobipReports(startDate?: string, endDate?: string) {
    const params = new URLSearchParams();

    if (startDate) {
      params.set('startDate', startDate);
    }

    if (endDate) {
      params.set('endDate', endDate);
    }

    const query = params.toString();
    const url = query
      ? `/reports/infobip?${query}`
      : '/reports/infobip';

    return this.simpleGet(url);
  }

  requestInfobipReport(
    shopId: number,
    startDate: string,
    endDateExclusive: string
  ) {
    const url = '/reports/infobip';

    const body = {
      shopId,
      startDate,
      endDateExclusive
    };

    return this.simplePost(url, JSON.stringify(body));
  }

  getVirtualAgentConfig() {
    let url = `/chatBots/admin/virtualAgent`;
    return this.simpleGet(url);
  }

  getShopsAgents() {
    let url = `/chatBots/admin/shopsAgents`;
    return this.simpleGet(url);
  }

  async getShopPointById(shopPointId: number, shopId: number) {
    let url = `/shoppoints/${shopPointId}?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  async getShopPoints(shopId: number): Promise<any[]> {
    let url = `/shoppoints?shopId=${shopId}`;
    return this.simpleGet(url) as Promise<any[]>;
  }

  getShopSocialChannels() {
    let url = `/chatBots/admin/shopSocialChannels`;
    return this.simpleGet(url);
  }

  getShopSocialChannelsByShopId(shopId: number) {
    let url = `/chatBots/shopSocialChannels/${shopId}`;
    return this.simpleGet(url);
  }

  createShopSocialChannel(
    shopId: number,
    shopGuid: string,
    channelType: string,
    channelId: string,
    sender: string,
    apiKey: string,
    apiHostUri: string,
    isActive: Boolean,
    shopPointId: string
  ) {
    let url = `/chatBots/admin/shopSocialChannels`;
    let body = {
      shopId,
      shopGuid,
      channelType,
      channelId,
      sender,
      apiKey,
      apiHostUri,
      isActive,
      shopPointId
    };
    console.log('body', body);
    return this.simplePost(url, JSON.stringify(body));
  }

  createShopAgent(
    shopId: number,
    infobip_key: string,
    infobip_url: string,
    enabled: boolean,
    phone_number: number,
    agent_code: string,
    shopGuid: string
  ) {
    let url = `/chatBots/admin/shopsAgents`;
    let body = {
      shopId,
      infobip_key,
      infobip_url,
      enabled,
      phone_number,
      agent_code,
      shopGuid
    }
    return this.simplePost(url, JSON.stringify(body));
  }

  updateShopSocialChannel(id: number, shopId: number, channelType: string, channelId: string, sender: string, apiKey: string, apiHostUri: string, isActive: Boolean, shopPointId: string) {
    let url = `/chatBots/admin/shopSocialChannels/${channelId}`;
    let body = {
      id,
      shopId,
      channelType,
      channelId,
      sender,
      apiKey,
      apiHostUri,
      isActive,
      shopPointId
    };
    return this.simplePut(url, JSON.stringify(body));
  }

  deleteShopSocialChannel(id: number, shopId: number) {
    let url = `/chatBots/admin/shopSocialChannels/delete`;
    let body = {
      id,
      shopId
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  updateShopAgent(
    shopId: number,
    shopPointId: number,
    newAgentId: string
  ) {
    let url = `/chatBots/admin/shopsAgents`;
    let body = {
      shopId,
      shopPointId,
      newAgentId
    };
    return this.simplePut(url, JSON.stringify(body));
  }

  deleteShopPointAgent(
    shopId: number,
    shopPointId: number,
    agentIdToRemove: string
  ) {
    let url = `/chatBots/admin/shopsAgents/delete`;
    let body = {
      shopId,
      shopPointId,
      agentIdToRemove
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  updateShopInfo(
    shopId: number,
    shopName: string,
    shopDomain: string,
    shopSubscriptionId: number,
    shopApiKey: number,
    infobip_api_key: number,
    infobip_sender: number,
    infobip_api_host_uri: number
  ) {
    let url = `/shop/data`;
    let body = {
      shopId,
      shopName,
      shopDomain,
      shopSubscriptionId,
      shopApiKey,
      infobip_api_key,
      infobip_sender,
      infobip_api_host_uri
    };
    return this.simplePut(url, JSON.stringify(body));
  }

  getSubscriptions() {
    let url = `/shops/subscriptions`;
    return this.simpleGet(url);
  }

  async getSubscriptionData(shopSubscriptionId: number) {
    let url = `/shops/subscriptions/${shopSubscriptionId}`;
    return this.simpleGet(url);
  }

  async createShopSubscription(
    shopSubscriptionName: string,
    shopPosAccess: number,
    shopAnaliticsAccess: number,
    shopMaxUsers: number,
    shopMaxProducts: number,
    shopProductTypesAllow: string,
    shopInfobipIntegrationAllow: number,
    shopValidateClientAccess: number,
    shopCalendarAccess: number,
    shopCashRegisterAccess: number,
    shopImportExportAllow: Json,
    shopLogsAllow: Json,
    shopPlanAllow: Json
  ) {
    let url = `/shops/subscriptions`;
    let body = {
      shopSubscriptionName,
      shopPosAccess,
      shopAnaliticsAccess,
      shopMaxUsers,
      shopMaxProducts,
      shopProductTypesAllow,
      shopInfobipIntegrationAllow,
      shopValidateClientAccess,
      shopCalendarAccess,
      shopCashRegisterAccess,
      shopImportExportAllow,
      shopLogsAllow,
      shopPlanAllow
    };
    return this.simplePost(url, JSON.stringify(body));
  }

  async updateShopSubscriptionData(
    shopSubscriptionId: number,
    shopSubscriptionName: string,
    shopPosAccess: number,
    shopAnaliticsAccess: number,
    shopMaxUsers: number,
    shopMaxProducts: number,
    shopProductTypesAllow: string,
    shopInfobipIntegrationAllow: number,
    shopValidateClientAccess: number,
    shopCalendarAccess: number,
    shopCashRegisterAccess: number,
    shopImportExportAllow: string,
    shopLogsAllow: string,
    shopPlanAllow: string
  ) {
    let url = `/shops/subscriptions`;
    let body = {
      shopSubscriptionId,
      shopSubscriptionName,
      shopPosAccess,
      shopAnaliticsAccess,
      shopMaxUsers,
      shopMaxProducts,
      shopProductTypesAllow,
      shopInfobipIntegrationAllow,
      shopValidateClientAccess,
      shopCalendarAccess,
      shopCashRegisterAccess,
      shopImportExportAllow,
      shopLogsAllow,
      shopPlanAllow
    };
    return this.simplePut(url, JSON.stringify(body));
  }

  async getShopSales(
    shopId: number,
    searchString: string,
    counter: number,
    amount: number,
    startDate: string,
    endDate: string,
    paymentTypeId: string,
    saleState: number | null
  ) {
    let url = `/sales?shopId=${shopId}&searchString=${searchString}&counter=${counter}&amount=${amount}&startDate=${startDate}&endDate=${endDate}&paymentTypeId=${paymentTypeId}&saleState=${saleState}`;
    return this.simpleGet(url);
  }

  updateVirtualAgentConfig(
    id: string,
    shopId: string,
    enabled: boolean,
  ) {
    let url = `/chatBots/virtualAgent/${id}`;
    let body = {
      shopId,
      enabled
    };
    return this.simplePut(url, JSON.stringify(body));
  }

  //---------------------AI TRAINING WORKSPACE--------------------//

  getTrainingEntries(shopId: number) {
    let url = `/chatBots/admin/trainingEntries?shopId=${shopId}`;
    return this.simpleGet(url);
  }

  createTrainingEntry(shopId: number, question: string, answer: string, topic: string) {
    let url = `/chatBots/admin/trainingEntries`;
    let body = { shopId, question, answer, topic };
    return this.simplePost(url, JSON.stringify(body));
  }

  updateTrainingEntry(id: number, shopId: number, question: string, answer: string, topic: string) {
    let url = `/chatBots/admin/trainingEntries/${id}`;
    let body = { id, shopId, question, answer, topic };
    return this.simplePut(url, JSON.stringify(body));
  }

  deleteTrainingEntry(id: number, shopId: number) {
    let url = `/chatBots/admin/trainingEntries/delete`;
    let body = { id, shopId };
    return this.simplePost(url, JSON.stringify(body));
  }

}
